import SearchBar from 'components/SearchBar/SearchBar';
import TextToggle from 'components/UI/TextToggle';
import { useState } from 'react';
import DeviceQueryControl from './components/DeviceQueryControl/DeviceQueryControl';
import List from './components/List/List';

const DeviceList = ({
  startTime, // the page's query window, lifted here by DeviceQueryControl through the setters
  endTime,
  setEndTime = () => {},
  setStartTime = () => {},
  setShowCurrentDevice = () => {},
  updateSelectedDevice,
  showCurrentDevice = false,
  widget = false,
}) => {
  const [showGroups, setShowGroups] = useState(false);

  return (
    <div className="d-flex flex-column w-100 h-100 min-h-0 p-2 gap-3 overflow-hidden">
      <DeviceQueryControl
        __setStartTime={setStartTime}
        __setEndTime={setEndTime}
        setShowCurrentDevice={setShowCurrentDevice}
      />
      <div className="d-flex gap-3">
        <TextToggle
          options={['All Devices', 'Groups']}
          value={showGroups}
          setValue={setShowGroups}
        />
        <SearchBar includeClear />
      </div>
      <div className="flex-grow-1 min-h-0">
        <List
          showGroups={showGroups}
          updateSelectedDevice={updateSelectedDevice}
          showCurrentDevice={showCurrentDevice}
          setShowCurrentDevice={setShowCurrentDevice}
          widget={widget}
          startTime={startTime}
          endTime={endTime}
        />
      </div>
    </div>
  );
};

export default DeviceList;
